import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=0f386a2e&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=0f386a2e&lang=scss&scoped=true&"
import style1 from "./TaskDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f386a2e",
  null
  
)

export default component.exports